export default __webpack_public_path__ + "static/media/linkedIn.2fbdc51b.png";